//import {auth} from "@/plugins/auth";
import Vue from "vue";
import Router from "vue-router";

import "@/views/LoginPage.vue";
import "@/views/Home.vue";
import "@/views/ItemOverview.vue";
import "@/views/ItemDetails.vue";
import "@/views/Lockers.vue";
import "@/views/History.vue";

import { getRoutes } from "@rocketbase/vue-extra-decorators";
import { auth } from "@/plugins";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: getRoutes()
});

router.beforeEach(async (to, from, next) => {
  await auth?.ensureInitialized();
  if (!auth.isLoggedIn() && !to.path.includes("/authentication"))
    next("/authentication/login");
  else next();
});
